goog.provide('el8.appshared.dialog.patientFields');

goog.require('el8.appchart.dialog.ordermed.selectPharmacy');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.practiceSettings');
goog.require('el8.template.appshared.dialog.patientForm');
goog.require('el8.appshared.dialog.guarantor');
goog.require('el8.util.amplitude.demographicsHelpers');
goog.require('el8.util.consts');


el8.appshared.dialog.patientFields = (function() {

    return {

        getFields: function() {
            var that = this; // FormDialog

            var fields = [
                {
                    name: 'firstName',
                    infoText: 'First Name (required)',
                    maxLength: 35,
                    validate: {
                        required: true,
                        maxlength: 35
                    }
                },
                {
                    name: 'middleName',
                    infoText: 'Middle Name',
                    maxLength: 35,
                    validate: { maxlength: 35 }
                },
                {
                    name: 'lastName',
                    infoText: 'Last Name (required)',
                    maxLength: 35,
                    validate: {
                        required: true,
                        maxlength: 35
                    }
                },
                {
                    name: 'dob',
                    infoText: Date.format,
                    datePickerOpts: {},
                    isDate: true,
                    validate: {
                        required: true,
                        validDate: true,
                        todayOrBefore: true,
                        afterYear1900 : true
                    }
                },
                {
                    name: 'sex',
                    validate: { required: true }
                },
                {
                    name: 'ssn',
                    infoText: 'XXX-XX-XXXX',
                    validate: { ssn: true }
                },
                {
                    name: 'address',
                    infoText: 'Mailing Address',
                    maxLength: 35,
                    validate: { maxlength: 35 }
                },
                {
                    name: 'suite',
                    infoText: 'Suite or Apartment No.',
                    maxLength: 10,
                    validate: { maxlength: 10 }
                },
                {
                    name: 'city',
                    infoText: 'City',
                    maxLength: 35,
                    validate: { maxlength: 35 }
                },
                {
                    name: 'state',
                    infoText: 'XX',
                    validate: { state: true }
                },
                {
                    name: 'zip',
                    infoText: 'XXXXX-XXXX',
                    validate: { zip: true }
                },
                {
                    name: 'phone1',
                    infoText: 'e.g. 555-555-5555',
                    validate: { phone: true }
                },
                {
                    name: 'phone1Type',
                    defaultVal: 'Home'
                },
                {
                    name: 'phone2',
                    infoText: 'e.g. 555-555-5555',
                    validate: { phone: true }
                },
                {
                    name: 'phone2Type',
                    defaultVal: 'Cell Phone'
                },
                {
                    name: 'email',
                    infoText: 'e.g. abc@xyz.com',
                    maxLength: 75,
                    validate: {
                        email: true,
                        maxlength: 75
                    }
                },
                {
                    name: 'pharmacy1'
                },
                {
                    name: 'pharmacy2'
                },
                {
                    name: 'preferredContact'
                },
                {
                    name: 'nokFirstName',
                    infoText: 'First Name',
                    maxLength: 35,
                    validate: {
                        maxlength: 35
                    }
                },
                {
                    name: 'nokLastName',
                    infoText: 'Last Name',
                    maxLength: 35,
                    validate: {
                        maxlength: 35
                    }
                },
                {
                    name: 'nokRelationship'
                },
                {
                    name: 'nokPhone',
                    infoText: 'e.g. 555-555-5555',
                    validate: { phone: true }
                },
                {
                    name: 'nokAddress',
                    infoText: 'Mailing Address',
                    maxLength: 35,
                    validate: { maxlength: 35 }
                },
                {
                    name: 'nokSuite',
                    infoText: 'Suite or Apartment No.',
                    maxLength: 10,
                    validate: { maxlength: 10 }
                },
                {
                    name: 'nokCity',
                    infoText: 'City',
                    maxLength: 35,
                    validate: { maxlength: 35 }
                },
                {
                    name: 'nokState',
                    infoText: 'XX',
                    validate: { state: true }
                },
                {
                    name: 'nokZip',
                    infoText: 'XXXXX-XXXX',
                    validate: { zip: true }
                },
                {
                    name: 'apptRemindersOptOut'
                },
                {
                    name: 'primaryPhysicianUserId',
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'detailedRace',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'detailedSecondaryRace',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'detailedEthnicity',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'detailedSecondaryEthnicity',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'sexualOrientation'
                },
                {
                    name: 'genderIdentity'
                },
                {
                    name: 'preferredLanguageId',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'notes',
                    height: 6*el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    infoText: 'Misc notes...',
                    noGrow: true
                },
                {
                    name: 'employerId',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                }
            ];

            if (el8Globals.FEATURES.VIPAccessControl) {
                fields.push({
                    name: 'isVip'
                });
            }

            /**
             * Add error classes to the insurance input field.
             *
             * @param {string} formFieldName - name of the field in the form
             */
            var addInsuranceErrorClasses = function(formFieldName) {
                var form = that.getForm();
                var $inputField = $(form.getInputField(formFieldName));
                $inputField.addClass('hasInsuranceError');
                $inputField.closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').addClass('hasInsuranceErrorIcon');
            };

            /**
             * Remove error classes from the insurance input field
             *
             * @param {string} formFieldName - name of the field in the form
             */
            var removeInsuranceErrorClasses = function(formFieldName) {
                var form = that.getForm();
                var $inputField = $(form.getInputField(formFieldName));
                $inputField.removeClass('hasInsuranceError');
                $inputField.closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').removeClass('hasInsuranceErrorIcon');
            };

            /**
             * Curry function to set the correct company field and auto-focus the plan field
             *
             * @param {boolean} isSecondary - whether it's a secondary insurance
             */
            var insuranceCompanySelectFn = function(isSecondary) {
                return function(event, item) {
                    var f = that.getForm();
                    // set both the text and id field for company
                    var carrierField = isSecondary ? 'secondaryCarrier' : 'carrier';
                    var companyIdField = isSecondary ? 'secondaryCompanyId' : 'companyId';
                    // also check if company changed
                    var companyChanged = Number(f.getVal(companyIdField)) !== item.id;
                    f.setVal(carrierField, item.carrier || '');
                    f.setVal(companyIdField, item.id || '');

                    // if the company changed and there's an existing plan, reset it
                    var planIdField = isSecondary ? 'secondaryPlanId' : 'planId';
                    if (companyChanged && f.getVal(planIdField)) {
                        var planField = isSecondary ? 'secondaryPlan' : 'plan';
                        f.setVal(planField, '');
                        f.setVal(planIdField, '');
                        removeInsuranceErrorClasses(planField);
                    }

                    removeInsuranceErrorClasses(carrierField);
                    // auto-focus onto the plan text field next
                    _.defer(function() {
                        var planField = isSecondary ? 'secondaryPlan' : 'plan';
                        var planInput = f.getInputField(planField);
                        $(planInput).focusFocus();
                        $(planInput).select();
                    });
                };
            };

            /**
             * Curry function to set the correct plan field and auto-focus the groupId field
             *
             * @param {boolean} isSecondary - whether it's a secondary insurance
             */
            var insurancePlanSelectFn = function(isSecondary) {
                return function(event, item) {
                    var f = that.getForm();

                    // set both the text and id field for plan
                    var planField = isSecondary ? 'secondaryPlan' : 'plan';
                    var planIdField = isSecondary ? 'secondaryPlanId' : 'planId';
                    f.setVal(planField, item.name || '');
                    f.setVal(planIdField, item.id || '');
                    removeInsuranceErrorClasses(planField);

                    // if the company id is empty, auto-populate the company fields
                    var companyIdField = isSecondary ? 'secondaryCompanyId' : 'companyId';
                    if (!f.getVal(companyIdField)) {
                        var companyField = isSecondary ? 'secondaryCarrier' : 'carrier';
                        f.setVal(companyIdField, item.company_id);
                        f.setVal(companyField, item.carrier);
                        removeInsuranceErrorClasses(companyField);
                    }

                    // auto-focus onto the groupId text field next
                    _.defer(function () {
                        var groupIdField = isSecondary ? 'secondaryGroupId' : 'groupId';
                        var groupIdInput = f.getInputField(groupIdField);
                        $(groupIdInput).focusFocus();
                        $(groupIdInput).select();
                    });
                };
            };

            /**
             * returns bool - if practice settings admin only is enabled and user is admin
             */
            var isAdminOnly = function() {
                return  el8.data.practiceSettings.isInsuranceSettingsAdminOnly()
                    && !el8.data.currUser.isPracticeAdmin();
            };

            /**
             * Check if the insurance field is filled out and default saying it's not
             * completely filled out. insuranceCompanySelectFn will run after if
             * a structured insurance is selected to clear the error classes.
             *
             * @param {string} formFieldName
             * @returns {function}
             */
            var handleInsuranceFieldChange = function(formFieldName) {
                return function() {
                    var freeTextToIdFields = el8.appshared.dialog.patientFields.insuranceFreeTextFieldToIdFields;

                    var clearPlanFields = function() {
                        var planTextFieldName = formFieldName.includes('secondary') ? 'secondaryPlan' : 'plan';
                        var planHiddenFieldName = freeTextToIdFields[planTextFieldName];
                        form.setVal(planTextFieldName, '');
                        form.setVal(planHiddenFieldName, '');
                        removeInsuranceErrorClasses(planTextFieldName);
                    };

                    var form = that.getForm();
                    var idFieldName = freeTextToIdFields[formFieldName];
                    // clear the id field, select happens after change which will
                    // set it if needed. If none wasn't selected, we shouldn't
                    // keep the old company/plan id
                    form.setVal(idFieldName, '');
                    if (formFieldName.toLowerCase().includes('carrier')) {
                        clearPlanFields();
                    }
                    if (form.getVal(formFieldName) || '') {
                        addInsuranceErrorClasses(formFieldName);
                    } else {
                        removeInsuranceErrorClasses(formFieldName);
                    }
                };
            };

            // actually create all the mindreader options
            var primaryCompanyMindreaderOpts = function () {
                return $.extend(el8.appshared.mindreaderOpts.insuranceCompanies(), {
                    changeFn: handleInsuranceFieldChange('carrier'),
                    selectFn: insuranceCompanySelectFn(false),
                    actions: [
                        {
                            name: '+ Add new insurance',
                            actionFn: function() {
                                el8React.dispatch.openInsuranceDialog(null, 'primary');
                            },
                            isDisabled: isAdminOnly()
                        }
                    ]
                });
            };

            var primaryPlanMindreaderOpts = function() {
                return $.extend(el8.appshared.mindreaderOpts.insurancePlansWithCompanies(), {
                    dynamicQueryParamsFn: function() {
                        // we want to filter by company if one is already selected
                        var f = that.getForm();
                        return {
                            company_id: f.getVal('companyId') || ''
                        };
                    },
                    changeFn: handleInsuranceFieldChange('plan'),
                    selectFn: insurancePlanSelectFn(false),
                    actions: [
                        {
                            name: '+ Add new plan',
                            actionFn: function() {
                                var f = that.getForm();
                                var companyId = Number(f.getVal('companyId')) || null;
                                el8React.dispatch.openInsuranceDialog(companyId, 'primary');
                            },
                            isDisabled: isAdminOnly()
                        }
                    ]
                });
            };

            var secondaryCompanyMindreaderOpts = function() {
                return $.extend(el8.appshared.mindreaderOpts.insuranceCompanies(), {
                    changeFn: handleInsuranceFieldChange('secondaryCarrier'),
                    selectFn: insuranceCompanySelectFn(true),
                    actions: [
                        {
                            name: '+ Add new insurance',
                            actionFn: function() {
                                el8React.dispatch.openInsuranceDialog(null, 'secondary');
                            },
                            isDisabled: isAdminOnly()
                        }
                    ]
                });
            };

            var secondaryPlanMindreaderOpts = function() {
                    return $.extend(el8.appshared.mindreaderOpts.insurancePlansWithCompanies(), {
                    dynamicQueryParamsFn: function() {
                        // we want to filter by company if one is already selected
                        var f = that.getForm();
                        return {
                            company_id: f.getVal('secondaryCompanyId') || ''
                        };
                    },
                    changeFn: handleInsuranceFieldChange('secondaryPlan'),
                    selectFn: insurancePlanSelectFn(true),
                    actions: [
                        {
                            name: '+ Add new plan',
                            actionFn: function() {
                                var f = that.getForm();
                                var companyId = Number(f.getVal('secondaryCompanyId')) || null;
                                el8React.dispatch.openInsuranceDialog(companyId, 'secondary');
                            },
                            isDisabled: isAdminOnly()
                        }
                    ]
                });
            };
            var filterNonDecimal = function(event) {
                return event.currentTarget.value.replace(/[^\d\.]/gi, '');
            };

            // add the insurance company and plan fields
            fields.push({
                name: 'carrier',
                infoText: 'e.g. Blue Cross',
                newMindreader: true,
                mindreaderOpts: primaryCompanyMindreaderOpts
            });

            fields.push({
                name: 'plan',
                infoText: 'e.g. Gold PPO',
                newMindreader: true,
                mindreaderOpts: primaryPlanMindreaderOpts
            });

            fields.push({
                name: 'secondaryCarrier',
                infoText: 'e.g. Blue Cross',
                newMindreader: true,
                mindreaderOpts: secondaryCompanyMindreaderOpts
            });

            fields.push({
                name: 'secondaryPlan',
                infoText: 'e.g. Gold PPO',
                newMindreader: true,
                mindreaderOpts: secondaryPlanMindreaderOpts
            });

            var extraInsuranceFields = [
                {
                    name: 'insuranceId'
                },
                {
                    name: 'companyId'
                },
                {
                    name: 'planId'
                },
                {
                    name: 'groupId',
                    infoText: 'Insurance Group No.'
                },
                {
                    name: 'memberId',
                    infoText: 'Insurance Member No.'
                },
                {
                    name: 'paymentProgram'
                },
                {
                    name: 'patientEmployer',
                    infoText: 'Employer Name'
                },
                {
                    name: 'copay',
                    infoText: "e.g., $20",
                    changeFn: function(event) { event.currentTarget.value = filterNonDecimal(event); },
                },
                {
                    name: 'deductible',
                    infoText: "e.g., $1000",
                    changeFn: function(event) { event.currentTarget.value = filterNonDecimal(event); },
                },
                {
                    name: 'insuredPersonFirstName',
                    infoText: "First name"
                },
                {
                    name: 'insuredPersonLastName',
                    infoText: "Last name"
                },
                {
                    name: 'relationshipToInsured'
                },
                {
                    name: 'insuredPersonAddress',
                    maxLength: 200,
                    infoText: 'Street'
                },
                {
                    name: 'insuredPersonCity',
                    maxLength: 50,
                    infoText: 'City'
                },
                {
                    name: 'insuredPersonState',
                    maxLength: 2,
                    infoText: 'State'
                },
                {
                    name: 'insuredPersonZip',
                    maxLength: 10,
                    infoText: 'Zip'
                },
                {
                    name: 'insuredPersonId'
                },
                {
                    name: 'insuredPersonSsn',
                    infoText: 'XXX-XX-XXXX',
                    validate: { ssn: true } // maybe
                },
                {
                    name: 'insuredPersonDob',
                    infoText: Date.format,
                    datePickerOpts: {},
                    isDate: true,
                    validate: {
                        validDate: true,
                        todayOrBefore: true,
                        afterYear1900 : true
                    }
                },
                {
                    name: 'insuredPersonGender'
                },
                {
                    name: 'secondaryInsuranceId'
                },
                {
                    name: 'secondaryCompanyId'
                },
                {
                    name: 'secondaryPlanId'
                },
                {
                    name: 'secondaryGroupId',
                    infoText: 'Insurance Group No.'
                },
                {
                    name: 'secondaryMemberId',
                    infoText: 'Insurance Member No.'
                },
                {
                    name: 'secondaryPaymentProgram'
                },
                {
                    name: 'secondaryPatientEmployer',
                    infoText: 'Employer Name'
                },
                {
                    name: 'secondaryCopay',
                    infoText: "e.g., $20",
                    changeFn: function(event) { event.currentTarget.value = filterNonDecimal(event); },
                },
                {
                    name: 'secondaryDeductible',
                    infoText: "e.g., $1000",
                    changeFn: function(event) { event.currentTarget.value = filterNonDecimal(event); },
                },
                {
                    name: 'secondaryInsuredPersonFirstName',
                    infoText: "First name"
                },
                {
                    name: 'secondaryInsuredPersonLastName',
                    infoText: "Last name"
                },
                {
                    name: 'secondaryRelationshipToInsured'
                },
                {
                    name: 'secondaryInsuredPersonAddress',
                    maxLength: 200,
                    infoText: 'Street'
                },
                {
                    name: 'secondaryInsuredPersonCity',
                    maxLength: 50,
                    infoText: 'City'
                },
                {
                    name: 'secondaryInsuredPersonState',
                    maxLength: 2,
                    infoText: 'State'
                },
                {
                    name: 'secondaryInsuredPersonZip',
                    maxLength: 10,
                    infoText: 'Zip'
                },
                {
                    name: 'secondaryInsuredPersonId'
                },
                {
                    name: 'secondaryInsuredPersonSsn',
                    infoText: 'XXX-XX-XXXX',
                    validate: { ssn: true } // maybe
                },
                {
                    name: 'secondaryInsuredPersonDob',
                    infoText: Date.format,
                    datePickerOpts: {},
                    isDate: true,
                    validate: {
                        validDate: true,
                        todayOrBefore: true,
                        afterYear1900 : true
                    }
                },
                {
                    name: 'secondaryInsuredPersonGender'
                }
            ];

            fields = fields.concat(extraInsuranceFields);

            if (el8Globals.FEATURES.FrontOfficeNewKareo) {

                fields.push({
                    type: 'select',
                    name: 'referringProviderState',
                    selector: ':input[name="referringProviderState"]', // note :input selector
                    changeFn: function () {
                        var f = that.getForm();
                        f.getInputField('referringProvider').focusSelect();
                    }
                });

                var urlfn = function() {
                    // this = FormDialog via bind
                    var f = this.getForm();
                    return el8.service.urls.get('referringProvider', [f.getVal('referringProviderState')]);
                };

                fields.push({
                    name: 'referringProvider',
                    selector: ':input[name="referringProvider"]',
                    newMindreader: true,
                    mindreaderOpts: el8.appshared.mindreaderOpts.referringProvider({
                        url: _.bind(urlfn, that), // bind to read state from form
                        selectFn: function(event, item) {
                            var f = that.getForm();
                            f._selectedReferringProviderData = item;

                            // provider autocomplete weirdness - we could be getting either a
                            // canonical or a cmsphysician from autocomplete result. need to support both.
                            if (item.canonical_physician_id) {
                                f.setVal('referringProviderModel', 'CanonicalPhysician');
                                f.setVal('referringProviderModelId', item.canonical_physician_id);
                            } else {
                                f.setVal('referringProviderModel', 'CMSPhysician');
                                f.setVal('referringProviderModelId', item.npi);
                            }
                        }
                    }),
                    changeFn: function () {
                        // if user sets PCP to be empty, then we treat that as removing the PCP
                        // otherwise we consider it to just be editing free form text
                        var f = that.getForm();
                        if(f.getVal('referringProvider') === '') {
                            f.clearField('referringProviderModel');
                            f.clearField('referringProviderModelId');
                        }
                    },
                    focusFn: function () {
                        $('.referring-provider-state-section', that.getContentElt()).show();
                        that.adjustHeight();
                    }
                });

                fields.push({
                    name: 'referringProviderModel',
                    selector: ':input[name="referringProviderModel"]'
                });
                fields.push({
                    name: 'referringProviderModelId',
                    selector: ':input[name="referringProviderModelId"]'
                });
            }

            fields.push({
                name: 'pcpPhysicianName',
                selector: ':input[name="pcpPhysicianName"]',
                newMindreader: true,
                mindreaderOpts: el8.appshared.mindreaderOpts.referringProvider({
                    url: _.bind(function() {
                            // this = FormDialog via bind
                            var f = this.getForm();
                            return el8.service.urls.get('referringProvider', [f.getVal('pcpState')]);
                        }, that), // bind to read state from form
                    selectFn: function(event, item) {
                        // provider autocomplete weirdness - we could be getting either a
                        // canonical or a cmsphysician from autocomplete result. need to support both.
                        var f = that.getForm();
                        if (item.canonical_physician_id) {
                            f.setVal('pcpModel', 'CanonicalPhysician');
                            f.setVal('pcpModelId', item.canonical_physician_id);
                        } else {
                            f.setVal('pcpModel', 'CMSPhysician');
                            f.setVal('pcpModelId', item.npi);
                        }
                    },
                    formatSelected: function(item) {
                        if (!item) {return false;}
                        return item.name;
                    }
                }),
                changeFn: function () {
                    // if user sets PCP to be empty, then we treat that as removing the PCP
                    var f = that.getForm();
                    if(f.getVal('pcpPhysicianName') === '') {
                        f.clearField('pcpModel');
                        f.clearField('pcpModelId');
                    }
                }
            });
            fields.push({
                type: 'select',
                name: 'pcpState',
                selector: ':input[name="pcpState"]', // note :input selector
                changeFn: function () {
                    var f = that.getForm();
                    f.getInputField('pcpPhysicianName').focusSelect();
                }
            });
            fields.push({
                name: 'pcpModel',
                selector: ':input[name="pcpModel"]'
            });
            fields.push({
                name: 'pcpModelId',
                selector: ':input[name="pcpModelId"]'
            });

            return fields;
        },

        insuranceFieldNames: ['insuranceId', 'carrier', 'companyId', 'plan', 'planId',
                              'groupId', 'memberId', 'paymentProgram', 'patientEmployer',
                              'copay', 'deductible', 'insuredPersonFirstName', 'insuredPersonLastName',
                              'relationshipToInsured', 'insuredPersonAddress', 'insuredPersonCity',
                              'insuredPersonState', 'insuredPersonZip', 'insuredPersonId',
                              'insuredPersonSsn', 'insuredPersonDob', 'insuredPersonGender'
                             ],

        patientValidationOpts: {
            errorClass: 'invalid',
            success: 'valid',
            validClass: 'checked',
            highlight: function(element, errorClass) {
                $(element).addClass('hasError');
                $(element).closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').addClass('hasErrorIcon');
            },
            unhighlight: function(element, errorClass) {
                $(element).removeClass('hasError');
                $(element).closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').removeClass('hasErrorIcon');
            },
            errorPlacement: function(error, element) {} // keep hidden
        },

        /**
         * Update the hidden pharmacy input (for submission) and the dialog link text (for user feedback)
         *
         * @param {Object} formDialog
         * @param {Object} pharmacyNum - should be 1 or 2
         * @param {Object} newPharmacy
         */
        updatePreferredPharmacy: function (formDialog, pharmacyNum, newPharmacy) {

            var ncpdpid = newPharmacy ? newPharmacy.getNcpdpid() : '';
            var numTag = 'pharmacy'+pharmacyNum;
            formDialog.getForm().setVal(numTag, ncpdpid);
            $('.'+numTag+'-wrapper', formDialog.getContentElt()).html(
                el8.template.appshared.dialog.patientForm.pharmacy({
                    pharmacy: newPharmacy ? newPharmacy.asSoyMap() : null,
                    pharmacyNum: pharmacyNum
                })
            );
        },

        /**
         * Add listeners intended for the createPatient and editPatient dialogs for Preferred Pharmacy links
         *
         * @param {Object} formDialog - the FormDialog widget on which these fields live
         */
        addGuarantorLinkListeners: function(formDialog) {
            var that = this;

            // Note: this is guarded behing FONK or flags in the template
            formDialog.getContentElt()
                .on('click', '.edit-guarantor',  function() {
                    el8.appshared.dialog.guarantor.show({
                        formGuarantor: formDialog._guarantor,
                        callbackFn: function(guarantor) {
                            formDialog._guarantor = guarantor;
                            that.renderGuarantor(formDialog);
                        }
                    });
                });
        },

        addPharmacyLinkListeners: function (formDialog) {

            formDialog.getContentElt().on('click', '.change-pharmacy',  function(e) {
                var $this = $(this);
                var pharmacyNum = $this.data('num');
                if (pharmacyNum !== 1 && pharmacyNum !== 2) {
                    UIM && UIM.logError('Invalid pharmacyNum: ' + pharmacyNum);
                    return;
                }
                // don't use $.data because converting to int will drop leading zeroes, etc.
                var ncpdpid = $this.attr('data-ncpdpid');

                el8.appchart.dialog.ordermed.selectPharmacy.show({
                    pharmacyNcpdpid: ncpdpid || null,
                    includePreferred: false,
                    saveCallbackFn: function(selectedPharmacy) {
                        el8.appshared.dialog.patientFields.updatePreferredPharmacy(formDialog, pharmacyNum, selectedPharmacy);
                    },
                    hidePrintButton: true
                });
            });

            formDialog.getContentElt().on('click', '.remove-pharmacy',  function(e) {
                var pharmacyNum = $(this).data('num');
                if (pharmacyNum !== 1 && pharmacyNum !== 2) {
                    UIM && UIM.logError('Invalid pharmacyNum: ' + pharmacyNum);
                    return;
                }

                el8.appshared.dialog.patientFields.updatePreferredPharmacy(formDialog, pharmacyNum, null);
            });
        },

        disableInsuranceFieldsIfOneWayKareoIntegrated: function(formDialog) {
            if (el8.data.currPractice.isKareoIntegrated() && el8Globals.FEATURES.OneWayKareoInsur) {
                var form = formDialog.getForm();
                el8.appshared.dialog.patientFields.insuranceFieldNames.forEach(function(fieldName) {
                    var secondaryFieldName = 'secondary' + fieldName[0].toUpperCase() + fieldName.substring(1);
                    form.getInputField(fieldName).prop('disabled', true);
                    form.getInputField(secondaryFieldName).prop('disabled', true);
                });
            }
        },

        addInsuranceLinkListeners: function(formDialog) {
            var primaryInsuranceDetailsTrigger = $('.insurance-details-trigger', formDialog.getContentElt());
            el8.uiwidget.collapsible({
                container: $('.insurance-details-section', formDialog.getContentElt()),
                triggerElt: primaryInsuranceDetailsTrigger,
                statusElt: primaryInsuranceDetailsTrigger,
                statusTextCollapse: 'show more',
                statusTextExpand: 'show less',
                isCollapsed: true,
                collapseFn: function() { formDialog.adjustHeight(); },
                expandFn: function() { formDialog.adjustHeight(); }
            });

            var secondaryInsuranceDetailsTrigger = $('.secondary-insurance-details-trigger', formDialog.getContentElt());
            el8.uiwidget.collapsible({
                container: $('.secondary-insurance-details-section', formDialog.getContentElt()),
                triggerElt: secondaryInsuranceDetailsTrigger,
                statusElt: secondaryInsuranceDetailsTrigger,
                statusTextCollapse: 'show more',
                statusTextExpand: 'show less',
                isCollapsed: true,
                collapseFn: function() { formDialog.adjustHeight(); },
                expandFn: function() { formDialog.adjustHeight(); }
            });

            var form = formDialog.getForm();
            var dialog = formDialog;
            formDialog.getContentElt()
                .on('change', '.optional-section-controller',  function() {
                    var controllerName = $(this).attr('name');
                    var isSecondary = controllerName.startsWith('secondary');
                    var employerSectionClass = isSecondary ? '.secondary-patient-employer' : '.patient-employer';
                    var $linkedSection = $(employerSectionClass + '[data-controller="' + controllerName + '"]', dialog.getContentElt());
                    var $nextFocusInput;

                    // Only do this for workers comp which has data-match
                    var match = $(this).data('match');
                    var insuredSectionClass = isSecondary ? '.secondary-insured-section' : '.insured-section';
                    var relationshipSelector = 'select[name="' + isSecondary ? 'secondaryRelationshipToInsured' : 'relationshipToInsured' + '"]';

                    if (match === form.getVal(controllerName)) {
                        $linkedSection.show();
                        // focus into the first of the newly shown fields
                        var $nextFocusInput = $(':input:first', $linkedSection);

                        if (match === 'workers_compensation') {
                            $(insuredSectionClass, dialog.getContentElt()).hide();
                            var $relToIns = $(relationshipSelector, dialog.getContentElt());
                            $relToIns.val('other'); // set to other

                            // Also populate patientEmployer, if available
                            if (el8.ptdata.currPatient) {
                                $nextFocusInput.val(el8.ptdata.currPatient.getPatientEmployer());
                            }
                        }
                    } else {
                        var $relToIns = $(relationshipSelector, dialog.getContentElt());
                        $relToIns.val(''); // reset to self

                        $linkedSection.hide();
                        // also empty the inputs so we don't post junk to the server later
                        // The `blur()` causes the infotext to reset
                        $(':input', $linkedSection).val('').blur();
                        // skip the focus ahead of the hidden fields

                        $nextFocusInput = $(':input[name="' + (isSecondary ? 'secondaryCopay' : 'copay') + '"]');
                        $(insuredSectionClass, dialog.getContentElt()).show();
                    }
                    form.focusField($nextFocusInput.attr('name'));
                    dialog.adjustHeight();
                });
        },

        insuranceFreeTextFieldToIdFields: {
            carrier: 'companyId',
            plan: 'planId',
            secondaryCarrier: 'secondaryCompanyId',
            secondaryPlan: 'secondaryPlanId'
        },

        /**
         * Check the main insurance fields to see if the user filled out some free text
         * but never actually selected a structured company/plan
         *
         * @param {Form} form - the form object from a FormDialog
         */
        insuranceFreeTextFieldsValid: function(form) {
            var freeTextToStructuredIdFields = el8.appshared.dialog.patientFields.insuranceFreeTextFieldToIdFields;
            var freeTextFields = Object.keys(freeTextToStructuredIdFields);

            for (var idx = 0; idx < freeTextFields.length; idx++) {
                if (form.getVal(freeTextFields[idx]) && !form.getVal(freeTextToStructuredIdFields[freeTextFields[idx]])) {
                    return false;
                }
            }

            return true;
        },

        resetInsuranceFreeTextErrorClasses: function(form) {
            var freeTextToStructuredIdFields = el8.appshared.dialog.patientFields.insuranceFreeTextFieldToIdFields;
            Object.keys(freeTextToStructuredIdFields).forEach(function(formFieldName) {
                var $inputField = $(form.getInputField(formFieldName));
                $inputField.removeClass('hasInsuranceError');
                $inputField.closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').removeClass('hasInsuranceErrorIcon');
            });
        },

        addPatientConsentListeners: function(formDialog) {
            formDialog.getContentElt()
                .on('change', '.consent-value',  function(e) {
                    var elt = $(e.currentTarget);
                    var value = elt.val();
                    var consentId = elt.data().id;
                    var valueBool = null;

                    var apps = el8.data.currPractice.getApplications();
                    var apps_with_consent = _.filter(apps, function(a) { return a.consent_available && a.is_active; });

                    if (value === '') {
                        return;
                    } else {
                        valueBool = value === 'y' ? true : false;
                    }

                    if (consentId) {
                        var consent = el8.ptdata.model.consents.getById(consentId);
                        consent.setConsented(valueBool);
                        el8.ptdata.model.consents.saveItem(consent, false, {
                            successCb: function(data) {
                                el8.appshared.dialog.patientFields.renderConsentLines(
                                    formDialog,
                                    apps_with_consent
                                );
                            }
                        });
                    } else {
                        var spec = {
                            'isConsented': valueBool,
                            'application': elt.data()['application']
                        };
                        el8.ptdata.model.consents.saveNew(spec, false, {
                            successCb: function(data) {
                                el8.appshared.dialog.patientFields.renderConsentLines(
                                    formDialog,
                                    apps_with_consent
                                );
                            }
                        });
                    }
                });
        },

        addPatientProviderLinkListeners: function(formDialog) {
            formDialog.getContentElt()
                .on('click', '.set-practice-primary-physician-as-pcp',  function(e) {
                        // copies the user from the primary provider in this practice, and sends
                        // User + user id to the server side when saving
                        var form = formDialog.getForm();
                        var userId = form.getVal('primaryPhysicianUserId');
                        form.setVal('pcpModel','User');
                        form.setVal('pcpModelId',userId);
                        form.setVal('pcpPhysicianName', $('select[name="primaryPhysicianUserId"] option:selected').text());

                }).on('click', '.set-referring-provider-as-pcp',  function(e) {
                    var form = formDialog.getForm();
                    var referringProvider = form.getVal('referringProvider');
                    // if disabled or referring provider field is empty, don't do anything
                    if ($(e.currentTarget).hasClass('disabled') || !referringProvider) {
                        e.preventDefault();
                        return;
                    }

                    var model = form.getVal('referringProviderModel');
                    var modelId = form.getVal('referringProviderModelId');

                    if (model && modelId) {
                        form.setVal('pcpModel', model);
                        form.setVal('pcpModelId', modelId);

                        // here we look up the provider name to copy over to PCP field

                        // if we have previously gotten the value set via autocomplete dropdown, use it
                        if (form._selectedReferringProviderData) {
                            form.setVal('pcpPhysicianName', form._selectedReferringProviderData.name);
                        } else {
                            // if it's canonicalphysician, we can look it up
                            if (model === 'CanonicalPhysician') {
                                $.el8_ajax({
                                    type: 'GET',
                                    url: el8.service.urls.get('canonicalPhysician', [modelId]),
                                    success: function(data) {
                                        form.setVal('pcpPhysicianName',
                                            data.credentials ? data.name + ', ' + data.credentials : data.name);
                                    }
                                });
                            } else {
                                // if all else fails, we copy the text from referringProvider field
                                form.setVal('pcpPhysicianName', form.getVal('referringProvider'));
                            }
                        }
                    } else {
                        el8.appshared.dialog.epnSearchPrompt.show({
                            promptMessage: "You can only mark known provider profiles as a Patient's Primary Care Provider. Try searching for this provider in Elation Provider Network.",
                            searchString: form.getVal('referringProvider')
                        });
                    }

                }).on('click', '.add-referring-provider-to-care-team',  function(e) {
                    // if disabled or referring provider field is empty, don't do anything
                    var form = formDialog.getForm();
                    var referringProvider = form.getVal('referringProvider');
                    if ($(e.currentTarget).hasClass('disabled') || !referringProvider) {
                        e.preventDefault();
                        return;
                    }

                    var model = form.getVal('referringProviderModel');
                    var modelId = form.getVal('referringProviderModelId');

                    var physician;
                    if (model === 'CanonicalPhysician') {
                        physician = el8.data.physicians.physicianFromCanonical(modelId);
                    } else if (model === 'CMSPhysician') {
                        physician = el8.data.physicians.physicianFromNpi(modelId);
                    }

                    if (!physician) { return; }

                    el8.ptdata.ptProviders.createMainProvider({
                        physicianId: physician.getId(),
                        successCb: function(provider) {
                            el8.ptdata.ptProviders.trigger('MOVED_MAIN', provider.getId());
                        }
                    });
                }).on('change', ':input[name="referringProvider"]',  function() {
                    // when user clears the referringProvider field, we clear
                    // all the referringProvider information
                    var form = formDialog.getForm();
                    var val = form.getVal('referringProvider');
                    if (val === '') {
                        form.clearField('referringProviderModel');
                        form.clearField('referringProviderModelId');
                        $('.add-referring-provider-to-care-team').addClass('disabled');
                        $('.set-referring-provider-as-pcp').addClass('disabled');
                    } else {
                        $('.add-referring-provider-to-care-team').removeClass('disabled');
                        $('.set-referring-provider-as-pcp').removeClass('disabled');
                    }
                });
        },

        populateInsuranceCompanyFromReact: function(formDialog, insuranceCompany, insuranceRank) {
            var form = formDialog.getForm();

            var carrierFormField = insuranceRank === 'primary' ? 'carrier' : 'secondaryCarrier';
            var companyIdFormField = insuranceRank === 'primary' ? 'companyId' : 'secondaryCompanyId';

            form.setVal(carrierFormField, insuranceCompany.carrier);
            form.setVal(companyIdFormField, insuranceCompany.id);
        },

        populateInsurancePlanFromReact: function(formDialog, insurancePlan, insuranceRank) {
            var form = formDialog.getForm();

            var planFormField = insuranceRank === 'primary' ? 'plan' : 'secondaryPlan';
            var planIdFormField = insuranceRank === 'primary' ? 'planId' : 'secondaryPlanId';

            form.setVal(planFormField, insurancePlan.name);
            form.setVal(planIdFormField, insurancePlan.id);
        },

        populateInsuranceFields: function(formDialog) {
            var primaryInsuranceMap = formDialog._primaryInsurance ?
                formDialog._primaryInsurance.asSoyMap() : {};
            var secondaryInsuranceMap = formDialog._secondaryInsurance ?
                formDialog._secondaryInsurance.asSoyMap() : {};

            if (el8.ptdata.currPatient) {
                [primaryInsuranceMap, secondaryInsuranceMap].forEach(function(insuranceMap) {
                    insuranceMap.patientEmployer = el8.ptdata.currPatient.getPatientEmployer();
                });
            }

            // set form values for both primary and secondary insurance fields
            el8.appshared.dialog.patientFields.insuranceFieldNames.forEach(function(fieldName) {
                var form = formDialog.getForm();
                var secondaryFieldName = 'secondary' + fieldName[0].toUpperCase() + fieldName.substring(1);
                if (fieldName === 'insuranceId') {
                    form.setVal(fieldName, primaryInsuranceMap.id);
                    form.setVal(secondaryFieldName, secondaryInsuranceMap.id);
                } else {
                    // strip out insurance from fieldName and camelcase the rest
                    form.setVal(fieldName, primaryInsuranceMap[fieldName] || '');
                    form.setVal(secondaryFieldName, secondaryInsuranceMap[fieldName] || '');
                }
            });
        },

        renderGuarantor: function(formDialog, currGuarantor) {
            // Use passed in guarantor if exists, otherwise use one attached to form
            var guarantor = currGuarantor ? currGuarantor : formDialog._guarantor;

            var guarantorStr = 'Add (if not self)';
            if (guarantor && guarantor.getRelationship()) { // Could be nulled out
                guarantorStr = guarantor.getRelationship().capitalize() + ': ' + guarantor.getFirstName() + ' ' + guarantor.getLastName();
            }

            $('.edit-guarantor', formDialog.getContentElt()).html(guarantorStr);
        },

        addSecondarySectionListener: function(formDialog, sectionName) {
            var $content = formDialog.getContentElt();
            $content.on('click', '.show-secondary-' + sectionName, function() {
                $(this).hide();
                $('.secondary-'+sectionName+'-section', $content).show();
            });
        },
        setSecondarySectionVisible: function(formDialog, sectionName, visible) {
            var $content = formDialog.getContentElt();
            if (visible) {
                $('.secondary-'+sectionName+'-section', $content).show();
                $('.show-secondary-'+sectionName, $content).hide();
            } else {
                $('.secondary-'+sectionName+'-section', $content).hide();
                $('.show-secondary-'+sectionName, $content).show();
            }
        },

        /**
         * Auto-trim email address field because users often paste it in with extra whitespace
         */
        autoTrimEmailListener: function (formDialog) {
            formDialog.getContentElt().on('change', ':input[name="email"]',  function() {
                var form = formDialog.getForm();
                form.setVal('email', form.getVal('email').trim(), true);
            });
        },

        populateAndSetState: function (formDialog, inputName) {
            var form = formDialog.getForm();
            $(form.getInputField(inputName), form.getContainer()).html(
                el8.template.appshared.location.stateSelect({
                    states: el8.util.consts.STATES,
                    selected: el8Globals.PRACTICE_STATE
                })
            );
        },

        /**
         * populate and set default ref provider state
        */
        populateAndSetReferringProviderState: function (formDialog) {
            this.populateAndSetState(formDialog, 'referringProviderState');
        },

        populateAndSetPrimaryCareProviderState: function (formDialog) {
            this.populateAndSetState(formDialog, 'pcpState');
        },

        /**
         * Load phone types, races, ethnicities, SOs and GIs if necessary
         */
        softLoadPatientFormInfo: function() {
            if (!el8.data.phoneTypes.length ||
                !el8.data.races.length ||
                !el8.data.ethnicities.length ||
                !el8.data.sexualOrientations.length ||
                !el8.data.genderIdentities.length) {
                $.el8_ajax({
                    url: el8.service.urls.get('patientFormInfo'),
                    type: 'GET',
                    async: false,
                    success: function(data) {
                        el8.data.phoneTypes = $.parseJSON(data['phone_types']);
                        el8.data.races = $.parseJSON(data['races']);
                        el8.data.ethnicities = $.parseJSON(data['ethnicities']);
                        el8.data.sexualOrientations = $.parseJSON(data['sexual_orientations']);
                        el8.data.genderIdentities = $.parseJSON(data['gender_identities']);
                    }
                });
            }
        },

        addRemoveSettingDependentFields: function(form) {
            // these fields are going to be hidden...
            // make sure they aren't submitted to the server
            if (!el8.data.practiceSettings.isApptRemindersEnabled() ||
                !el8Globals.FEATURES.ApptReminders) {

                form.removeField('apptRemindersOptOut');
            }
        },

        prepareInsuranceDataForPost: function(formMap, formDialog) {
            if (el8.data.currPractice.isKareoIntegrated() && el8Globals.FEATURES.OneWayKareoInsur) {
                return formMap;
            }
            var primaryInsuranceMap = formDialog._primaryInsurance ?
                formDialog._primaryInsurance.asSoyMap() : {};
            var secondaryInsuranceMap = formDialog._secondaryInsurance ?
                formDialog._secondaryInsurance.asSoyMap() : {};

            var primaryChanged = false;
            var secondaryChanged = false;

            var primaryInsurance = {};
            var secondaryInsurance = {};
            this.insuranceFieldNames.forEach(function(fieldName) {

                var underscoreName = fieldName.fromCamelToUnderscore();
                var secondaryUnderscoreName = 'secondary_' + underscoreName;
                if (['insuranceId', 'carrier', 'plan'].includes(fieldName)) {
                    // we'll handle setting insurance ID later on, and we don't want to
                    // pass the carrier/plan freetext fields back to the server
                    return;

                } else {
                    primaryInsurance[underscoreName] = formMap[underscoreName];
                    if (primaryInsurance[underscoreName] !== (primaryInsuranceMap[fieldName] && primaryInsuranceMap[fieldName].toString())) {
                        primaryChanged = true;
                    }
                    secondaryInsurance[underscoreName] = formMap[secondaryUnderscoreName];
                    if (secondaryInsurance[underscoreName] !== (secondaryInsuranceMap[fieldName] && secondaryInsuranceMap[fieldName].toString())) {
                        secondaryChanged = true;
                    }
                }
            });
            // if any field changed, we'll not send the original patient insurance ID so
            // that we will create a new one (PMS like Kareo want new ones when details change)
            primaryInsurance.id = primaryChanged ? null : primaryInsuranceMap.id;
            secondaryInsurance.id = secondaryChanged ? null : secondaryInsuranceMap.id;
            formMap['primary_insurance'] = primaryInsurance;
            formMap['secondary_insurance'] = secondaryInsurance;
            return formMap;
        },

        prepareGuarantorDataForPost: function(formMap, formDialog) {
            var guarantorData = null;
            if (formDialog._guarantor) {
                guarantorData = {};
                Object.keys(formDialog._guarantor.rawData).forEach(function (fieldName) {
                    var underscoreName = fieldName.fromCamelToUnderscore();
                    guarantorData[underscoreName] = formDialog._guarantor.rawData[fieldName];
                });
            }

            formMap['guarantor'] = guarantorData;
            return formMap;
        },

        // Render the list of employer <option>s
        updateEmployerOptions: function(formDialog, patientDialogForm) {
            var $employerSection = $('.employer-section', formDialog.getContentElt());
            $employerSection.hide();
            el8.data.employers.load();  // gave up trying to do soft load in the right way.  sorry
            var employers = el8.data.employers.allAsSoyMaps();
            if (employers.length > 0) {
                // by default, we don't show the "Employer" section
                // if the practice is not associated with any employer
                $employerSection.show();
                patientDialogForm.getInputField('employerId').html(
                  el8.template.appshared.dialog.patientForm.employerOptions({
                      employers: employers
                  })
                );
            }
        },

        updateReferringProviderLinks: function(formDialog) {
            var form = formDialog.getForm();
            // this is a temporary variable holding for the referring provider selected from autocomplete
            form._selectedReferringProviderData = null;

            if (form.getVal('referringProvider')) {
                $('.set-referring-provider-as-pcp', formDialog.getContentElt()).removeClass('disabled');
                $('.add-referring-provider-to-care-team', formDialog.getContentElt()).removeClass('disabled');
            } else {
                $('.set-referring-provider-as-pcp', formDialog.getContentElt()).addClass('disabled');
                $('.add-referring-provider-to-care-team', formDialog.getContentElt()).addClass('disabled');
            }
        },

        renderConsentLines: function(formDialog, apps) {
            // Lines allow editing existing pt consents and allow
            // for new consent creation per consent available app
            var consentLines = [];

            apps.forEach(function(app) {
                var found = _.find(el8.ptdata.model.consents.allAsSoyMaps(), function(consent) {
                    return consent.application === app.name && consent.isActive === true;
                });

                if (found) {
                    consentLines.push(found);
                } else {
                    consentLines.push({
                        'id': null,
                        'application': app.name,
                        'isConsented': null,
                        'lastUpdated': null,
                        'isActive': null,
                    });
                }
            });

            var $consentSection = $('.consents-section', formDialog.getContentElt());
            $consentSection.show();
            $('#consents-list', $consentSection).html(
                el8.template.appshared.dialog.patientForm.consents({
                    consentLines: consentLines
                })
            );

        }

    };

})();
